import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import styled from 'styled-components';
import { TransformedAssetClassForecastValueDto } from '../../../../types';

interface TableSumFooterProps {
  contributionsTableData: TransformedAssetClassForecastValueDto[];
  distributionsTableData: TransformedAssetClassForecastValueDto[];
  columnWidth: number;
}

interface AllocationSummary {
  [year: number]: number;
}

const TableSumFooter = ({ contributionsTableData, distributionsTableData, columnWidth }: TableSumFooterProps) => {
  const dateContributionsSummary: AllocationSummary = {};
  const dateDistributionsSummary: AllocationSummary = {};

  const addValueToSummary = (summary: AllocationSummary, date: string, allocation: number) => {
    const year = new Date(date).getFullYear();
    if (!summary[year]) {
      summary[year] = 0;
    }
    summary[year] += allocation;
  };

  contributionsTableData.forEach((assetClass) => {
    assetClass.values.forEach((allocation) => {
      addValueToSummary(dateContributionsSummary, allocation.date, allocation.value);
    });
  });

  distributionsTableData.forEach((assetClass) => {
    assetClass.values.forEach((allocation) => {
      addValueToSummary(dateDistributionsSummary, allocation.date, allocation.value);
    });
  });

  const calculateNetCashFlow = (contributions: AllocationSummary, distributions: AllocationSummary): AllocationSummary => {
    const result: AllocationSummary = {};
    for (const year in contributions) {
      if (distributions.hasOwnProperty(year) || contributions.hasOwnProperty(year)) {
        result[year] = (distributions[year] || 0) - (contributions[year] || 0);
      }
    }
    return result;
  };

  const netCashFlow = calculateNetCashFlow(dateContributionsSummary, dateDistributionsSummary);

  return (
    <TableSumWrap>
      <TableSumItem width={15}>Net Cash Flow</TableSumItem>
      {Object.entries(netCashFlow).map(([year, value]) => (
        <TableSumItem key={year} width={columnWidth}>
          <FormattingTooltip zIndex={1000}>{value}</FormattingTooltip>
        </TableSumItem>
      ))}
    </TableSumWrap>
  );
};

const TableSumWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 60px;
  background-color: ${({ theme }) => theme.layer[2]};
  border-radius: 8px;
  padding: 0 24px;
`;

const TableSumItem = styled.div<{ width: number }>`
  display: flex;
  justify-content: flex-start;
  width: ${({ width }) => `${width}%`};
  color: ${({ theme }) => theme.font.base};
  font-family: Blinker, serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;
`;

export default TableSumFooter;
